import React, { useState } from "react";

const InputModal = ({
  open,
  title,
  label,
  initialValue = "",
  onCancel,
  onSubmit,
  placeholder = "",
}) => {
  const [value, setValue] = useState(initialValue);

  if (!open) return null;

  return (
    <div className="change-setting-modal-overlay">
      <div className="change-setting-modal-container" style={{ maxWidth: 350 }}>
        <div className="change-setting-modal-title">{title}</div>
        <input
          className="change-setting-input"
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={e => setValue(e.target.value)}
          autoFocus
        />
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
          <button className="change-setting-secondary-btn" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="change-setting-primary-btn"
            onClick={() => onSubmit(value)}
            disabled={!value.trim()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputModal;
